const LARGE_COUNT = 1_000_000_000n
const scientific = new Intl.NumberFormat('en-US', {
  notation: 'scientific',
  maximumFractionDigits: 2,
})

/** Exact below a billion; IPv6 pools beyond that read as 1.84E19. */
export function formatCount(value: bigint): string {
  return value >= LARGE_COUNT
    ? scientific.format(value)
    : value.toLocaleString('en-US')
}

export function formatAmount(value: number | undefined, digits = 1): string {
  return value === undefined
    ? '—'
    : value.toLocaleString('en-US', { maximumFractionDigits: digits })
}

export function formatShare(value: number | undefined): string {
  return value === undefined ? '—' : `${(value * 100).toFixed(1)}%`
}
